<template>
  <section>
    <partner-banner :group="group" :key="group.title" />
    <ul class="bg-cl-primary m0 px20 pb40 products">
      <product v-for="(product, index) in group.items"
               :key="product.item_hash || `${product.sku}-${index}`"
               :product="product"
               :partner="group.partner"
               :display_mode="group.partner.display_mode"
      />
      <delivery-coverage-progress v-if="hasAddress && group.delivery != null && group.partner.shipping.delivery_price_coverage.length" :delivery-price="group.delivery"
                                  :delivery-price-coverage="group.partner.shipping.delivery_price_coverage"
                                  :subtotal="group.subtotal"
      />
    </ul>
    <upsell-slider :group="group" />
  </section>
</template>

<script async>
import { mapGetters } from 'vuex';
import PartnerBanner from './PartnerBanner';
import Product from 'theme/components/core/blocks/Microcart/Product'
const DeliveryCoverageProgress = () => import(/* webpackChunkName: "kz-cart-delivery-progress" */ 'theme/components/core/blocks/Microcart/Partner/DeliveryCoverageProgress.vue');
const UpsellSlider = () => import(/* webpackChunkName: "kz-cart-upsell" */ 'theme/components/core/blocks/Microcart/UpsellSlider.vue');

export default {
  name: 'PartnerMicrocart',
  components: {
    PartnerBanner,
    Product,
    DeliveryCoverageProgress,
    UpsellSlider
  },
  props: {
    group: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters({
      hasAddress: 'address/getHasAddress'
    })
  }
}
</script>

<style lang="scss" scoped>
  .products{
    @media only screen and (max-width: 768px) {
      padding: 0 12px 40px;
    }

    @media (max-width: 400px) {
      padding-left: 10px !important;
      padding-right: 10px;
    }
    @media (max-width: 350px) {
      padding-left: 5px !important;
    }
  }
  .progress {
    width: 90%;
    padding-top: 20px;
    margin: 0 auto;
    position: relative;
  }

  .progress-container {
    position: relative;
    width: 100%;
    height: 6px;
    background-color: #e0e0e0;
    border-radius: 3px;
  }

  .progress-bar {
    height: 100%;
    background-color: #ffa500;
    width: 0;
    border-radius: 3px;
  }

  .progress-anchors {
    position: absolute;
    top: -20px; /* move anchors above the bar */
    left: 0;
    right: 0;
    height: 30px;
  }

  .goal-anchor {
    position: absolute;
    transform: translateX(-50%);
    font-size: 14px;
    color: black;
    font-weight: bold;
    white-space: nowrap;
  }
  .delivery-price-info {
    font-size: 16px;
    color: black;
    font-weight: bold;
    display: flex;
    justify-content: center;
    text-align: center;
  }
</style>
